import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from "./Apiurl";
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/EditSquare';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import { withStyles } from "@mui/styles";

import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import BlockIcon from '@mui/icons-material/Block';
import DomainIcon from '@mui/icons-material/Domain';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
const headCells = [


 
  
  { id: 'pj_projectname', numeric: false, label: 'Project Name' },
  { id: 'pj_customername', numeric: false, label: 'Customer' },
  { id: 'pj_phoneno', numeric: false, label: 'Phone No.' },
  { id: 'pj_emailid', numeric: false, label: 'Email id' },
  { id: 'projectstatus', numeric: false, label: 'Status' },
   { id: '',  label: '' },
  ]
  
  

 
 function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Usermaster extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Projectdata:[],pjid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',custname:'',names:'',searchcustomer:'',prstatus:'0',pj_margin: ''
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   this.addProjectboxRef = React.createRef();
	}
	
	updateDonenewParent = (text) => {  this.apicall(this.state.page,this.state.rowsPerPage);  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Projectdata:[]
    });
	
//this.componentDidMount();  
}
		componentWillMount() { 
 if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
	  let strname="Projects";   
			 this.props.parentsCallback(
           strname
        );
		document.title = "VR Builders - Projects";
		 localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
}









  


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxprojects.php?action=getall&pj_projectname='+this.state.names+'&pj_customername='+this.state.custname+'&pj_projectstatus='+this.state.prstatus+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Projectdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Projectdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage);});
   
 
    
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      projectDelete(pjid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('pj_id',pjid)
	 	   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxprojects.php", formData, {
        }).then(res => {
    
          
   
 
this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }
	  projectblock(pjid,state){  
	
let strmsg=" Block";
	
	if(state===0)
	{
		strmsg=" Unblock";
	}
let r = window.confirm("Do you really want to "+strmsg+"?");
 if(r === true){ 
 var formData = new FormData();
     formData.append('action','statusupdate')
	 formData.append('pj_id',pjid)
	 	 formData.append('pj_isactive',state)   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxprojects.php", formData, {
        }).then(res => {
    
           this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }
Projectaddbox = (id) => {
  if (id === 0) {
    this.setState({ redirect: true, pagename: "/addnewproject" });
  } else {
    this.setState({ redirect: true, pagename: "/addnewproject/" + id });
  }
};
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   




   <div className="searchmaster">


  
  <ul>
  

		
		<li><p>Projects</p>
 <p ><TextField
            variant="outlined" className="inputcntlparent"  size="small"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Project Name"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
		  	<li><p>Customer Name</p>
 <p ><TextField
            variant="outlined" className="inputcntlparent" size="small"
            margin="normal"
            fullWidth value={this.state.custname}
           inputProps={{tabIndex: "2",maxLength:150}}
			placeholder="Customer Name"
            name="custname" onChange={this.myChangeHandler}
		
          /></p></li>
			 <li><p>Status</p>
 	<p><FormControl  className="stadrp">			   
		<Select className="inputcntlparent" size="small"
		variant="outlined"
		native
		value={this.state.prstatus}
		onChange={this.myChangeHandler}
		name='prstatus'
		id='prstatus'
		placeholder="Project Status"
		InputLabelProps={{
		shrink: true,
		}}
		>
			<option value="">Select Status</option>
		<option value={0}>Active</option>
		<option value={1}>In Active</option>

				
		</Select>
		</FormControl></p>	
</li>
<li>
<p className="searchbutton">
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button>	<Button variant="contained" onClick={()=>{this.Projectaddbox(0)}} className="pointerbtn" endIcon={<AddIcon />}>
        New
      </Button></p>
</li>
	</ul>
		
	
		
		
		
</div>		




<Paper >


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Projectdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Projectdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell><a href={"/Projectwisedetailes?projectId="+item.pj_id} target="_blank">{item.pj_projectname}</a></TableCell>
<TableCell><a href={"/Projectwisedetailes?projectId="+item.pj_id} target="_blank">{item.pj_customername}</a></TableCell>
<TableCell><a href={"/Projectwisedetailes?projectId="+item.pj_id} target="_blank">{item.pj_phoneno}</a></TableCell>
<TableCell><a href={"/Projectwisedetailes?projectId="+item.pj_id} target="_blank">{item.pj_emailid}</a></TableCell>
<TableCell><a href={"/Projectwisedetailes?projectId="+item.pj_id} target="_blank">{item.projectstatus}</a></TableCell>
<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="editbtn" onClick={()=>{this.Projectaddbox(item.pj_id)}} endIcon={<EditIcon />}>

</Button>&nbsp;

 
 

<Button variant="contained" className="deletebtn" onClick={()=>{this.projectDelete(item.pj_id)}} endIcon={<DeleteIcon />}>

</Button> &nbsp;

 {item.pj_isactive !=='1' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtnblock" onClick={()=>{this.projectblock(item.pj_id,1)}} endIcon={<DomainIcon />}>

</Button> 
 </React.Fragment>)}
 {item.pj_isactive !=='0' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtn" onClick={()=>{this.projectblock(item.pj_id,0)}} endIcon={<DomainDisabledIcon />}>

</Button> 
 </React.Fragment>)}
 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />   
 
   </Paper>
    

 </React.Fragment> 

 
 
  );
}
}

